var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18V5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.997 5.125a4 4 0 0 1 2.526 5.77"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18a4 4 0 0 0 2-7.464"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18a4 4 0 0 1-2-7.464"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.003 5.125a4 4 0 0 0-2.526 5.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.a55f6e2884d2dfb0ca523cc0ff3c3383.svg";
export { ForwardRef as ReactComponent };